import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["recipientsContainer", "recipient", "addRecipientSaveButton", "recipientCheckbox", "sendNotificationButton", "notificationRecipients"]
  static values = {
    formId: String,
  }

  addRecipient() {
    fetch(`/forms/${this.formIdValue}/recipients/new`)
      .then((res) => res.text())
      .then((partial) => {
        partial = partial.replace(/NEW_ID/g, this.recipientTargets.length + 1)
        this.recipientsContainerTarget.insertAdjacentHTML("beforeend", partial)
        this.toggleSaveButton()
      })
  }

  removeRecipient(event) {
    event.target.closest("tr")?.remove()
    this.toggleSaveButton()
  }

  toggleSaveButton() {
    if (this.recipientTargets.length > 0) {
      this.addRecipientSaveButtonTarget.classList.remove("d-none")
      this.addRecipientSaveButtonTarget.classList.add("d-flex")
    } else {
      this.addRecipientSaveButtonTarget.classList.remove("d-flex")
      this.addRecipientSaveButtonTarget.classList.add("d-none")
    }
  }

  toggleAllRecipients(event) {
    const enabledCheckboxes = this.recipientCheckboxTargets.filter((checkbox) => !checkbox.disabled)
    const checked = event.target.checked === true
    enabledCheckboxes.forEach((checkbox) => {
      checkbox.checked = checked
    })
    const selected = checked ? enabledCheckboxes.map((checkbox) => parseInt(checkbox.value, 10)) : []
    this.notificationRecipientsTarget.value = JSON.stringify(selected)
    if (selected.length === 0) {
      this.sendNotificationButtonTarget.setAttribute("disabled", true)
    } else {
      this.sendNotificationButtonTarget.removeAttribute("disabled")
    }
  }

  toggleRecipient({ params }) {
    let recipients = JSON.parse(this.notificationRecipientsTarget.value || "[]")
    if (recipients.includes(params.recipient)) {
      recipients = recipients.filter((recipient) => recipient !== params.recipient)
    } else {
      recipients.push(params.recipient)
    }
    this.notificationRecipientsTarget.value = JSON.stringify(recipients)
    if (recipients.length === 0) {
      this.sendNotificationButtonTarget.setAttribute("disabled", true)
    } else {
      this.sendNotificationButtonTarget.removeAttribute("disabled")
    }
  }
}
